import EntitySelectionModal from '../components/entity-selection-modal';
import { DeclarationConstants } from '../constants/global';
import { openModal } from '../utilities/utils';

const useEntitySelectionModal = () => {
  const openEntityModal = (data?: { isSelectionRequired?: boolean }) => {
    const isSelectionRequired = data?.isSelectionRequired;

    openModal({
      title: DeclarationConstants.SELECT_ENTITY,
      content: (
        <EntitySelectionModal isSelectionRequired={isSelectionRequired} />
      ),
      className: 'w-[35rem] m-auto',
      disableBackDropClick: isSelectionRequired,
      disableEscapeKeyDown: isSelectionRequired,
    });
  };

  return { openEntityModal };
};

export default useEntitySelectionModal;
